module.exports = __webpack_public_path__ + "static/media/left-arrow.3bd68e51.png";